import styled, { css } from "styled-components";
import { breakpoints } from "../NavigationBar/theme";
import { AccountSwitcherLogo } from "./components/AccountSwitcherLogo/AccountSwitcherLogo";

type StyledTriggerProps = {
  isCollapsed: boolean;
};
export const StyledTrigger = styled(AccountSwitcherLogo)<StyledTriggerProps>`
  min-width: 40px;
  min-height: 40px;
  width: 40px;
  height: 40px;
  border-radius: 8px;

  @media screen and (max-height: ${breakpoints.heightM}px) {
    & {
      min-width: 32px;
      min-height: 32px;
      width: 32px;
      height: 32px;
      border-radius: 4px;
    }
  }
`;

export const ExpandedTrigger = styled.div`
  display: flex;
  flex: 1;
  gap: 8px;
  cursor: pointer;
  border-radius: 8px;

  &:hover {
    background: var(--sinch-sys-color-container-main-hover);
  }

  @media screen and (max-height: ${breakpoints.heightM}px) {
    & {
      border-radius: 4px;
    }
  }
`;

export const TriggerWrapper = styled.div<{ isCollapsed: boolean }>`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  padding: 10px;
  flex-direction: column;
  position: relative;

  ${({ isCollapsed }) =>
    isCollapsed &&
    css`
      align-items: center;
    `}
  @media screen and (max-height: ${breakpoints.heightS}px) {
    & {
      padding: 4px 10px;
    }
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: flex-end;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
